import React from "react"
import { Link } from 'react-router-dom'
import srcBackground from "../../../images/bg-charity-banner.png"
import Button from "../../Shared/Button"
import styles from "./styles.module.scss"

export default function CorporateBanner({time}) {
  return (
    <div className={styles.container}>
      <img className={styles.left} src={`${srcBackground}?${time}`} alt="Employees and clients will love your corporate culture of social responsibility. CSR." />
      <div className={styles.right}>
        <div className={styles.lblTitle}>When Meaningful Matters...</div>
        <div className={styles.title}>Build your Brand with Philanthropy</div>
        <div className={styles.subTitle}>
          Business Gifts and Events
        </div>
        <div className={styles.description}>
          Create a positive image of social responsibility for your company (CSR) and boosts employee morale.
        </div>
        <div className={styles.description}>
          The best program for cause-affinity, proven to be effective in enhancing customer loyalty.
          <br />
          It speaks volumes about your company's values.
        </div>
        <div className={styles.description}>
          We offer the most robust customization suite in the industry!
          <br />
          ...with an option to pre-select your own curated list of charities for clients to choose from.
        </div>
        <div className={styles.actions}>
          <Link to="/CorporateSolutions">
            <Button>Learn More</Button>
          </Link>
          <a href="/Login?CA=1">
            <Button outline color="yellow">Sign Up</Button>
          </a>
        </div>
      </div>
    </div>
  )
}
